import { render } from "./CatalogFilters.vue?vue&type=template&id=459051c9"
import script from "./CatalogFilters.vue?vue&type=script&lang=js"
export * from "./CatalogFilters.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/resources/shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__